import React from "react";
import ReactGA from "react-ga";

const Project = props => {
  const { name, link, image, description, github } = props;
  const { divs, text, githubimg } = styles;

  const handleClick = e => {
    ReactGA.event({
      category: "Project",
      action: "click",
      label: e.target.id,
      nonInteraction: true
    });
  };
  return (
    <div onClick={handleClick} style={divs} className="divs">
      <div style={text}>{name}</div>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img
          id={name.replace(/\s/g, "")}
          style={{ minHeight: "254" }}
          className="exwork"
          src={require(`${image}`)}
          alt={`${name}-Project`}
        />
      </a>
      <div style={text}>
        <p>{description}</p>
        <div style={styles.github}>
          {" "}
          <a href={github} target="_blank" rel="noopener noreferrer">
            {" "}
            <img
              style={githubimg}
              src={require("./assets/github.jpg")}
              alt={`${name}-gituhb`}
            />
          </a>{" "}
        </div>
      </div>
    </div>
  );
};

const styles = {
  divs: {
    margin: "1rem",
    borderRadius: "5%"
  },
  text: {
    width: "100%",
    textAlign: "center",
    margin: "2rem auto"
  },
  githubimg: {
    height: "60px",
    width: "60px",
    borderRadius: "50%"
  }
};

export default Project;
